import { StateCreator } from 'zustand';
import { AuthStore, AuthState } from '../types';

export const createStateSlice: StateCreator<AuthStore, [], [], AuthState> = () => ({
    data: null,
    loading: false,
    error: null,
    _navigate: null,
    superAdminView: false,
});
